import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {SLA_URL} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import RespAndResolutionDialog from "./RespAndResolutionDialog";
import SLADialog from "./SLADialog";
import EscalationDialog from "./EscalationDialog";

function SLAs() {

  const [cursor] = useState("pointer");
  const [slaData, setSlaData] = useState([]);

  useEffect(() => {
    getSLAs();
  }, []);


  const getSLAs = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(SLA_URL).then((response) => setSlaData(response.data));
  };


  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <SLADialog slaData={slaData} callSLAs={getSLAs} />
      </Box>

      <AppTableView
        rows={slaData}
        cols={[
          { field: "name", headerName: "Name", flex: 1 },
          {
            field: "requestType",
            headerName: "SLA Type",
            flex: 1,
            renderCell: (params) => params.row?.requestType.name,
          },
          {
            field: "operationalHours",
            headerName: "Operational Hours",
            flex: 1,
            renderCell: (params) => params.row?.operationalHours?.name,
          },
          {
            field: "organization",
            headerName: "Organization",
            flex: 1,
            renderCell: (params) => params.row?.organization.name,
          },
          {
            field: "respAndResol",
            headerName: "Resp & Resol",
            flex: 1,
            renderCell: (params) => (
              <RespAndResolutionDialog slaId={params.row.id} />
            ),
          },
          {
            field: "escalation",
            headerName: "Escalation",
            flex: 1,            
             renderCell: (params) => (
              <EscalationDialog slaId={params.row.id} />
            ),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}

export default SLAs;
